import React from 'react'
import i18next from 'i18next'
import { ReservationStatusLabels } from 'types/common'
import type { ReservationFormProps } from 'types/applicant'
import type { ReservationDetailProps, ReservationListItem } from 'types/med'

export const reservationStatusLabelText: (
  status: ReservationFormProps | ReservationDetailProps | ReservationListItem
) => React.ReactNode = (reservation) => {
  // NOTE: 予約ステータスが「finish」で始まる場合のみReservationStatusLabelsは無視しconsultation_methodに応じてラベルを変更する
  if (reservation?.status?.startsWith('finish')) {
    return !!reservation.call_method &&
      reservation?.consultation_method !== 'in_person'
      ? i18next.t('通話完了')
      : i18next.t('実施完了')
  }
  return reservation?.status && ReservationStatusLabels[reservation.status]
    ? i18next.t(ReservationStatusLabels[reservation.status])
    : null
}
